import formatCarousels from './formatCarousels';
import initCarousels from './initCarousels';
import themeEditor from './themeEditor'; 

export default () => {
  formatCarousels();
  initCarousels();
  themeEditor();
};